export default function IntroSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
              Professional Apartment Buyers
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Sell My Apartments to Experienced Buyers in El Paso
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Are you thinking "I need to sell my apartments fast"? T-Rex Real Estate specializes in buying apartment buildings throughout El Paso and West Texas. Whether you own a small duplex, a mid-sized fourplex, or a large multi-family apartment complex, we have the experience, resources, and proven track record to make you a fair cash offer and close quickly.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Selling apartment buildings can be complex and time-consuming. Traditional real estate transactions for multi-family properties often take 6-12 months, involve extensive inspections, financing contingencies, and mountains of paperwork. As professional apartment buyers, we eliminate these headaches by purchasing your property directly with cash, closing through a reputable title company, and handling all the details from start to finish.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Our team has successfully purchased over 150 apartment buildings across Texas, ranging from 2-unit duplexes to 50-unit complexes. We buy apartments in any condition, with tenants in place or vacant, and regardless of deferred maintenance issues. When you work with T-Rex Real Estate, you're working with apartment buyers who have a documented track record of successful closings and satisfied sellers.
            </p>

            <div className="grid grid-cols-2 gap-6">
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="text-4xl font-bold text-teal-600 mb-2">150+</div>
                <div className="text-gray-700 font-semibold">Apartment Buildings Purchased</div>
              </div>
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="text-4xl font-bold text-teal-600 mb-2">$85M+</div>
                <div className="text-gray-700 font-semibold">Total Transaction Value</div>
              </div>
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="text-4xl font-bold text-teal-600 mb-2">7-14</div>
                <div className="text-gray-700 font-semibold">Days Average Closing</div>
              </div>
              <div className="bg-gray-50 rounded-xl p-6">
                <div className="text-4xl font-bold text-teal-600 mb-2">100%</div>
                <div className="text-gray-700 font-semibold">Title Company Closings</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/79c98e074b38128b89265df85abb811b.jpg"
                alt="Sell My Apartments to Professional Buyers"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -left-8 bg-teal-600 text-white rounded-2xl p-8 shadow-2xl max-w-xs">
              <div className="flex items-center space-x-4 mb-3">
                <i className="ri-verified-badge-fill text-4xl"></i>
                <div>
                  <div className="text-2xl font-bold">A+ Rated</div>
                  <div className="text-teal-100">BBB Accredited Business</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}